import { ROUTES } from '@/configs/routes';
import { formatDate } from '@/utils/formatDate';

import type { DetailPageKind } from '../types';
import { getDetailPageKind } from '../utils';

import { DetailHeaderConfig, DetailHeaderState } from './types';

const FALLBACK_TITLES: Record<DetailPageKind, string | null> = {
  news: null,
  note: 'Заметка',
  noteCreate: 'Новая заметка',
  noteEdit: 'Редактирование заметки',
  insight: 'Инсайт',
  insightCreate: 'Новый инсайт',
  insightEdit: 'Редактирование инсайта',
  followUp: 'Follow-up',
  followUpCreate: 'Новый follow-up',
  followUpEdit: 'Редактирование follow-up',
};

const BACK_TO_BY_KIND: Record<DetailPageKind, (organizationId: string) => string> = {
  news: ROUTES.organization.news.create,
  note: ROUTES.organization.notebook.notes.create,
  noteCreate: ROUTES.organization.notebook.notes.create,
  noteEdit: ROUTES.organization.notebook.notes.create,
  insight: ROUTES.organization.notebook.insights.create,
  insightCreate: ROUTES.organization.notebook.insights.create,
  insightEdit: ROUTES.organization.notebook.insights.create,
  followUp: ROUTES.organization.notebook.followUps.create,
  followUpCreate: ROUTES.organization.notebook.followUps.create,
  followUpEdit: ROUTES.organization.notebook.followUps.create,
};

export const buildDetailHeaderConfig = (
  pathname: string,
  organizationId: string | undefined,
  headerState: DetailHeaderState | null,
): DetailHeaderConfig | null => {
  const detailKind = getDetailPageKind(pathname);

  if (!detailKind) {
    return null;
  }

  const newsDateLabel = headerState?.newsUpdatedAt ?? headerState?.newsPublishDate;
  const detailDateRaw = headerState?.detailUpdatedAt ?? headerState?.detailCreatedAt;
  const detailDateLabel = detailDateRaw ? formatDate(detailDateRaw) : null;
  const detailTitle = detailDateLabel ? `Последнее изменение ${detailDateLabel}` : (headerState?.detailTitle ?? null);
  const newsTitle = newsDateLabel ? `Последнее изменение ${newsDateLabel}` : null;

  const titleByKind: Record<DetailPageKind, string | null> = {
    news: newsTitle,
    note: detailTitle ?? FALLBACK_TITLES.note,
    noteCreate: FALLBACK_TITLES.noteCreate,
    noteEdit: detailTitle ?? FALLBACK_TITLES.noteEdit,
    insight: detailTitle ?? FALLBACK_TITLES.insight,
    insightCreate: FALLBACK_TITLES.insightCreate,
    insightEdit: detailTitle ?? FALLBACK_TITLES.insightEdit,
    followUp: detailTitle ?? FALLBACK_TITLES.followUp,
    followUpCreate: FALLBACK_TITLES.followUpCreate,
    followUpEdit: detailTitle ?? FALLBACK_TITLES.followUpEdit,
  };

  const safeOrganizationId = organizationId ?? '';

  return {
    title: titleByKind[detailKind],
    backTo: BACK_TO_BY_KIND[detailKind](safeOrganizationId),
  };
};
